import { render, staticRenderFns } from "./NhstRegistration.vue?vue&type=template&id=20dc6f52"
import script from "./NhstRegistration.vue?vue&type=script&lang=js"
export * from "./NhstRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports